// feat: registro del Service Worker PWA (solo producción, solo si el navegador lo soporta)
//
// El import dinámico de 'virtual:pwa-register' evita que el módulo virtual de
// vite-plugin-pwa se resuelva en dev/test, donde no existe el SW generado.
export async function registerServiceWorker(): Promise<void> {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  const { registerSW } = await import('virtual:pwa-register');
  registerSW({ immediate: true });
}
